//
//
//
//
//
//
import utils from '@/utils';
export default {
  name: 'd2-time-relative',
  props: {
    value: {
      default: new Date(),
      required: false
    },
    interval: {
      default: 1000 * 60,
      required: false
    }
  },
  data: function data() {
    return {
      relativeTime: '',
      timer: null
    };
  },
  created: function created() {
    var _this = this;

    this.refresh();
    this.timer = setInterval(function () {
      _this.refresh();
    }, this.interval);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refresh: function refresh() {
      this.relativeTime = utils.time.dayjs(this.value).fromNow();
    }
  }
};